export function ifInTestingMode(value: string) {
  return process.env.NODE_ENV === 'test' ? value : undefined;
}
